import { Form, FormElement, FormError } from '@uplift/types';
import { restClient } from '../../client';

export type StartFormInput = {
  submission_id: string;
};

export type StartFormOutput =
  | {
    error: FormError;
  }
  | {
    form: Form;
    first_element: FormElement;
    total_elements: number;
  };

export const startForm = (data: StartFormInput) => restClient.request<StartFormOutput>('/api/v1/form/start', {
  method: 'POST',
  data
});
